import React, { Component } from 'react';
import { Link } from 'react-router-dom';



export default class Jumbotron extends Component {
  render() {
  return <div className="hero is-medium is-marginless">
    <div className="hero-body container has-text-centered">
      <h1 className="title">
        <span className="fa-stack fa-lg">
          <i className="fa fa-vk fa-stack-1x" aria-hidden="true"></i>
          <i className="has-text-danger fa fa-ban fa-stack-2x text-danger" aria-hidden="true"></i>
        </span>
        STOPVK
      </h1>
      <br /> <br />
      <h2 className="subtitle">Приложение для управления личными данными в социальной сети «ВКонтакте».</h2>
      <p className="has-text-left">
        За годы использования ВКонтакте накапливается много личной информации: фотографии, записи на стене, лайки, репосты, подписки. Всё это остаётся на серверах соцсети — даже то, о чём вы давно забыли.
      </p>
      <br />
      <p className="has-text-left">
        StopVK даёт удобный инструмент для просмотра и массового удаления ваших данных. Все операции выполняются через официальный API ВКонтакте — ваши данные не проходят через сторонние серверы.
      </p>
      <br />
      <p className="subtitle">
        Приложение умеет:
      </p>
      <br />
      <ul className="has-text-left">
        <li><strong>Фотографии</strong> — сохранение и удаление альбомов, снятие отметок и лайков</li>
        <li><strong>Стена</strong> — удаление записей</li>
        <li><strong>Закладки</strong> — удаление лайкнутых постов, видео, ссылок, товаров, страниц</li>
        <li><strong>Друзья, Группы, Видео</strong> — массовое удаление выбранных</li>
        <li><strong>Заметки, Документы</strong> — удаление</li>
      </ul>


      <br />
      <p className="subtitle">
        Для начала работы Вам нужно:
      </p>
      <Link to="/auth" className="button is-info is-large">
        <span className="icon">
          <i className="fa fa-vk"></i>
        </span>
        <span>Войти</span>
      </Link>


    </div>
  </div>
  }
}



// WEBPACK FOOTER //
// ./src/components/Jumbotron.js